export { default as MolliePaymentSkeleton } from "./MolliePaymentSkeleton";
